import { Component, Prop } from 'vue-property-decorator'
import Vue, { CreateElement } from 'vue'
import { H6 } from '@src/elements/typography/typography'
import { ExerciseCardPrint } from '@src/components/print/exercise-card-print'
import { LoadingScreen } from '@src/components/loading-screen/loading-screen/loading-screen'
import './print-exercises.sass'

@Component
export class PrintExercises extends Vue {

  @Prop({ required: true })
  exercises: any[]

  @Prop({ required: false })
  workoutName: string

  private loading = true

  created () {
    this.$nextTick(() => {
      const images = document.getElementsByTagName('img')
      this.checkImagesLoading(images)
    })
  }

  checkImagesLoading (images) {
    // print after all images are loaded
    let timer = window.setInterval(() => {
      if (!this.isLoading(images)) {
        this.loading = false
        window.print()
        clearInterval(timer)
      }
    },2000)
  }

  isLoading (images) {
    for (let i = 0; i < images.length; i++) if (images[i].className === 'exercise-preview' && !(images[i].complete)) return true
    return false
  }

  render (h: CreateElement) {
    return <div>
      {this.loading && <LoadingScreen /> }
      <div id='exercises-to-print' class='exercises-to-print'>
        {this.workoutName ? <H6 class='wo-title'> {this.workoutName} </H6> : ''}
        {this.exercises.map(exercise => <ExerciseCardPrint exercise={exercise} />)}
      </div>
    </div>
  }

}
